import React from 'react';
import ChooseUs from '../../components/ChooseUs';
import DownloadSection from '../../components/DownloadSection';
import HeroSlider from '../../components/HeroSlider';
import MenuPack from '../../components/MenuPack';
import PopularMenu from '../../components/PopularMenu';
import Testimonials from '../../components/Testimonials';
import PopUp from '../../features/PopUp';

const Home = () => {
    return (
        <>
            <PopUp />

            <HeroSlider />
            <PopularMenu />
            <ChooseUs />
            <MenuPack />

            <Testimonials titleParagraph={'What our customers are saying'} />
            <DownloadSection />
        </>
    );
};

export default Home;
